// extracted by mini-css-extract-plugin
module.exports = {"center":"a10a3f92e9--center--b3Pm0"};